import { Component } from '@angular/core';
import { Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Subscription } from 'rxjs/Subscription';
import { SQLite, SQLiteObject } from '@ionic-native/sqlite';
import { AppRate } from '@ionic-native/app-rate';
import { HomePage } from '../pages/home/home';
@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage:any = HomePage;
  pResume: Subscription;

  constructor(platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen
    , private sqlite: SQLite
    , private appRate: AppRate
    ) {
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();
      splashScreen.hide();

    });
  }



  initAppRate() {

  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts